
export const GET_GASPROJECTS = "GET_GASPROJECT"
export const GET_GASPROJECTS_SUCCESS = "GET_GASPROJECT_SUCCESS"
export const GET_GASPROJECTS_FAIL = "GET_GASPROJECT_FAIL"

export const GET_GASPROJECTS_FILTER = "GET_GASPROJECTS_FILTER"
export const GET_GASPROJECTS_FILTER_SUCCESS = "GET_GASPROJECTS_FILTER_SUCCESS"
export const GET_GASPROJECTS_FILTER_FAIL = "GET_GASPROJECTS_FILTER_FAIL"

export const GET_GASPROJECTS_FULL_FILTER = "GET_GASPROJECTS_FULL_FILTER"
export const GET_GASPROJECTS_FULL_FILTER_SUCCESS = "GET_GASPROJECTS_FULL_FILTER_SUCCESS"
export const GET_GASPROJECTS_FULL_FILTER_FAIL = "GET_GASPROJECTS_FULL_FILTER_FAIL"

export const GET_GASPROJECTS_FULL_FILTER_EXCEL = "GET_GASPROJECTS_FULL_FILTER_EXCEL"
export const GET_GASPROJECTS_FULL_FILTER_EXCEL_SUCCESS = "GET_GASPROJECTS_FULL_FILTER_EXCEL_SUCCESS"
export const GET_GASPROJECTS_FULL_FILTER_EXCEL_FAIL = "GET_GASPROJECTS_FULL_FILTER_EXCEL_FAIL"

export const GET_GASPROJECTS_ENG = "GET_GASPROJECTS_ENG"
export const GET_GASPROJECTS_ENG_SUCCESS = "GET_GASPROJECTS_ENG_SUCCESS"
export const GET_GASPROJECTS_ENG_FAIL = "GET_GASPROJECTS_ENG_FAIL"

export const GET_GASPROJECT_REPORT = "GET_GASPROJECT_REPORT"
export const GET_GASPROJECT_REPORT_SUCCESS = "GET_GASPROJECT_REPORT_SUCCESS"
export const GET_GASPROJECT_REPORT_FAIL = "GET_GASPROJECT_REPORT_FAIL"

export const GET_GASPROJECT_FILES = "GET_GASPROJECT_FILES"
export const GET_GASPROJECT_FILES_SUCCESS = "GET_GASPROJECT_FILES_SUCCESS"
export const GET_GASPROJECT_FILES_FAIL = "GET_GASPROJECT_FILES_FAIL"

export const GET_GASPROJECT_FREE = "GET_GASPROJECT_FREE"
export const GET_GASPROJECT_FREE_SUCCESS = "GET_GASPROJECT_FREE_SUCCESS"
export const GET_GASPROJECT_FREE_FAIL = "GET_GASPROJECT_FREE_FAIL"

export const GET_PACKAGEINSTALLER = "GET_PACKAGEINSTALLER"
export const GET_PACKAGEINSTALLER_SUCCESS = "GET_PACKAGEINSTALLER_SUCCESS"
export const GET_PACKAGEINSTALLER_FAIL = "GET_PACKAGEINSTALLER_FAIL"

export const INSERT_GASPROJECT = "INSERT_GASPROJECT"
export const INSERT_GASPROJECT_SUCCESS = "INSERT_GASPROJECT_SUCCESS"
export const INSERT_GASPROJECT_FAIL = "INSERT_GASPROJECT_FAIL"

export const UPSERT_GASPROJECT = "UPSERT_GASPROJECT"
export const UPSERT_GASPROJECT_SUCCESS = "UPSERT_GASPROJECT_SUCCESS"
export const UPSERT_GASPROJECT_FAIL = "UPSERT_GASPROJECT_FAIL"

export const UPDATE_GASPROJECT = "UPDATE_GASPROJECT"
export const UPDATE_GASPROJECT_SUCCESS = "UPDATE_GASPROJECT_SUCCESS"
export const UPDATE_GASPROJECT_FAIL = "UPDATE_GASPROJECT_FAIL"

export const UPDATE_GASPROJECT_ENG = "UPDATE_GASPROJECT_ENG"
export const UPDATE_GASPROJECT_ENG_NEW = "UPDATE_GASPROJECT_ENG_NEW"


export const DELETE_GASPROJECT = "DELETE_GASPROJECT"
export const DELETE_GASPROJECT_SUCCESS = "DELETE_GASPROJECT_SUCCESS"
export const DELETE_GASPROJECT_FAIL = "DELETE_GASPROJECT_FAIL"

export const UPDATE_GASPROJECT_DETAILS = "UPDATE_GASPROJECT_DETAILS"
export const UPDATE_GASPROJECT_DETAILS_SUCCESS = "UPDATE_GASPROJECT_DETAILS_SUCCESS"
export const UPDATE_GASPROJECT_DETAILS_FAIL = "UPDATE_GASPROJECT_DETAILS_FAIL"

export const UPDATE_GASPROJECT_DETAILS_NEW = "UPDATE_GASPROJECT_DETAILS_NEW"
export const UPDATE_GASPROJECT_DETAILS_NEW_SUCCESS = "UPDATE_GASPROJECT_DETAILS_NEW_SUCCESS"
export const UPDATE_GASPROJECT_DETAILS_NEW_FAIL = "UPDATE_GASPROJECT_DETAILS_NEW_FAIL"

export const ADD_FILE_GASPROJECT = "ADD_FILE_GASPROJECT"
export const ADD_FILE_GASPROJECT_SINGLE = "ADD_FILE_GASPROJECT_SINGLE"
export const ADD_FILE_GASPROJECT_SUCCESS = "ADD_FILE_GASPROJECT_SUCCESS"
export const ADD_FILE_GASPROJECT_FAIL = "ADD_FILE_GASPROJECT_FAIL"

export const UPDATE_PROCESS_EXPERT_STAGE = "UPDATE_PROCESS_EXPERT_STAGE"
export const UPDATE_PROCESS_MAP_STAGE = "UPDATE_PROCESS_MAP_STAGE"
export const UPDATE_PROCESS_DEFECT_STAGE = "UPDATE_PROCESS_DEFECT_STAGE"
export const UPDATE_PROCESS_STAGE_SUCCESS = "UPDATE_PROCESS_STAGE_SUCCESS"
export const UPDATE_PROCESS_STAGE_FAIL = "UPDATE_PROCESS_STAGE_FAIL"

export const UPDATE_PROCESS_EXPERT_STAGE_NEW = "UPDATE_PROCESS_EXPERT_STAGE_NEW"
export const UPDATE_PROCESS_MAP_STAGE_NEW = "UPDATE_PROCESS_MAP_STAGE_NEW"
export const UPDATE_PROCESS_DEFECT_STAGE_NEW = "UPDATE_PROCESS_DEFECT_STAGE_NEW"
export const UPDATE_PROCESS_STAGE_NEW_SUCCESS = "UPDATE_PROCESS_STAGE_NEW_SUCCESS"
export const UPDATE_PROCESS_STAGE_NEW_FAIL = "UPDATE_PROCESS_STAGE_NEW_FAIL"

export const SEND_GASPROJECT_TOGAS = "SEND_GASPROJECT_TOGAS"
export const SEND_GASPROJECT_TOGAS_SUCCESS = "SEND_GASPROJECT_TOGAS_SUCCESS"
export const SEND_GASPROJECT_TOGAS_FAIL = "SEND_GASPROJECT_TOGAS_FAIL"

export const SUBMIT_GASPROJECT_ADMIN = "SUBMIT_GASPROJECT_ADMIN"
export const SUBMIT_GASPROJECT_ADMIN_SUCCESS = "SUBMIT_GASPROJECT_ADMIN_SUCCESS"
export const SUBMIT_GASPROJECT_ADMIN_FAIL = "SUBMIT_GASPROJECT_ADMIN_FAIL"

export const ADD_PACKAGE_INSTALLER = "ADD_PACKAGE_INSTALLER"
export const ADD_PACKAGE_INSTALLER_SUCCESS = "ADD_PACKAGE_INSTALLER_SUCCESS"
export const ADD_PACKAGE_INSTALLER_FAIL = "ADD_PACKAGE_INSTALLER_FAIL"

export const SUBMIT_PACKAGE = "SUBMIT_PACKAGE"
export const SUBMIT_PACKAGE_SUCCESS = "SUBMIT_PACKAGE_SUCCESS"
export const SUBMIT_PACKAGE_FAIL = "SUBMIT_PACKAGE_FAIL"

export const RESET_PACKAGE = "RESET_PACKAGE"
export const RESET_PACKAGE_SUCCESS = "RESET_PACKAGE_SUCCESS"
export const RESET_PACKAGE_FAIL = "RESET_PACKAGE_FAIL"

export const STOP_GASPROJECT = "STOP_GASPROJECT"
export const STOP_GASPROJECT_SUCCESS = "STOP_GASPROJECT_SUCCESS"
export const STOP_GASPROJECT_FAIL = "STOP_GASPROJECT_FAIL"

export const RESOLVED_DEFECT = "RESOLVED_DEFECT"
export const RESOLVED_DEFECT_SUCCESS = "RESOLVED_DEFECT_SUCCESS"
export const RESOLVED_DEFECT_FAIL = "RESOLVED_DEFECT_FAIL"


export const PREPARE_MAPSTAGE = "PREPARE_MAPSTAGE"
export const PREPARE_MAPSTAGE_SUCCESS = "PREPARE_MAPSTAGE_SUCCESS"
export const PREPARE_MAPSTAGE_FAIL = "PREPARE_MAPSTAGE_FAIL"


export const PREPARE_FIRSTSUPERVISION_STAGE = "PREPARE_FIRSTSUPERVISION_STAGE"
export const PREPARE_FIRSTSUPERVISION_STAGE_SUCCESS = "PREPARE_FIRSTSUPERVISION_STAGE_SUCCESS"
export const PREPARE_FIRSTSUPERVISION_STAGE_FAIL = "PREPARE_FIRSTSUPERVISION_STAGE_FAIL"

export const PREPARE_DESIGNS_STAGE = "PREPARE_DESIGNS_STAGE"
export const PREPARE_DESIGNS_STAGE_SUCCESS = "PREPARE_DESIGNS_STAGE_SUCCESS"
export const PREPARE_DESIGNS_STAGE_FAIL = "PREPARE_DESIGNS_STAGE_FAIL"

export const SUBMIT_DESIGN_STAGE = "SUBMIT_DESIGN_STAGE"
export const SUBMIT_DESIGN_STAGE_SUCCESS = "SUBMIT_DESIGN_STAGE_SUCCESS"
export const SUBMIT_DESIGN_STAGE_FAIL = "SUBMIT_DESIGN_STAGE_FAIL"

export const SUBMIT_FIRSTSUPERVISION_STAGE = "SUBMIT_FIRSTSUPERVISION_STAGE"
export const SUBMIT_FIRSTSUPERVISION_STAGE_SUCCESS = "SUBMIT_FIRSTSUPERVISION_STAGE_SUCCESS"
export const SUBMIT_FIRSTSUPERVISION_STAGE_FAIL = "SUBMIT_FIRSTSUPERVISION_STAGE_FAIL"

export const UPDATE_GASPROJECT_CHECKLIST = "UPDATE_GASPROJECT_CHECKLIST"
export const UPDATE_GASPROJECT_CHECKLIST_SUCCESS = "UPDATE_GASPROJECT_CHECKLIST_SUCCESS"
export const UPDATE_GASPROJECT_CHECKLIST_FAIL = "UPDATE_GASPROJECT_CHECKLIST_FAIL"

export const DELETE_GASPROJECT_FILE = "DELETE_GASPROJECT_FILE";
export const DELETE_GASPROJECT_FILE_SUCCESS = "DELETE_GASPROJECT_FILE_SUCCESS";
export const DELETE_GASPROJECT_FILE_FAIL = "DELETE_GASPROJECT_FILE_FAIL";

export const PAY_BY_EXECUTOR_WALLET = "PAY_BY_EXECUTOR_WALLET"
export const PAY_BY_EXECUTOR_WALLET_SUCCESS = "PAY_BY_EXECUTOR_WALLET_SUCCESS"
export const PAY_BY_EXECUTOR_WALLET_FAIL = "PAY_BY_EXECUTOR_WALLET_FAIL"

export const GET_GASPROJECT_INFO_PUBLIC = "GET_GASPROJECT_INFO_PUBLIC"
export const GET_GASPROJECT_INFO_PUBLIC_SUCCESS = "GET_GASPROJECT_INFO_PUBLIC_SUCCESS"
export const GET_GASPROJECT_INFO_PUBLIC_FAIL = "GET_GASPROJECT_INFO_PUBLIC_FAIL"




export const RESET_GASPROJECT_FLAG = "RESET_GASPROJECT_FLAG"